import { routerSplitCharacter } from '@/utils/Constant'
let a = {
  checkPermission (value) {
    let permissionBtn = window.localStorage.getItem('permissionBtns') || ''
    if (!permissionBtn) {
      return false
    } else {
      permissionBtn = permissionBtn.split(routerSplitCharacter)
      return permissionBtn.indexOf(value) !== -1
    }
  }
}
export default a



// WEBPACK FOOTER //
// ./src/utils/CustomFunction.js